import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { FormsModule } from '@angular/forms';

import { ChartsModule } from 'ng2-charts';
import { RouterModule } from '@angular/router';
import { CumulativeCampaignStatisticsComponent } from './cumulative-campaign-statistics/cumulative-campaign-statistics.component';
import { IndividualCampaignStatisticsComponent } from './cumulative-campaign-statistics/individual-campaign-statistics/individual-campaign-statistics.component';
import { ShowCampaignMessageComponent } from './cumulative-campaign-statistics/individual-campaign-statistics/show-campaign-message/show-campaign-message.component';






@NgModule({
  declarations: [
    CumulativeCampaignStatisticsComponent,
    IndividualCampaignStatisticsComponent,
    ShowCampaignMessageComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    CoreModule,
    FormsModule,
    ChartsModule
  ],
  exports: [ShowCampaignMessageComponent]
})
export class ReportsModule { }
